import React from 'react'
import { useActions, useValues } from 'kea'
import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/search/logic'

import './styles.scss'

function Pagination () {
  const { updateFilter } = useActions(sceneLogic)
  const { results, options, filter } = useValues(sceneLogic)

  const {
    page,
    pages,
    count,
    total,
    per_page: perPage,
    helmet: { link }
  } = results

  const { coords_from_location: coordsFromLocation } = options
  const { from_map: fromMap } = filter

  const start = (page - 1) * perPage + 1
  const end = (page - 1) * perPage + count

  const prevPage = link.filter(l => l.rel === 'prev')[0]
  const nextPage = link.filter(l => l.rel === 'next')[0]

  const handlePrevPage = e => {
    e.preventDefault()

    updateFilter({ page: page - 1, coords_from_location: fromMap ? false : coordsFromLocation })
  }

  const handleNextPage = e => {
    e.preventDefault()

    updateFilter({ page: page + 1, coords_from_location: fromMap ? false : coordsFromLocation })
  }

  return (
    <div className='results-pagination'>
      <div className='left-button'>
        <a
          className='button'
          href={prevPage ? prevPage.href : '#'}
          onClick={handlePrevPage}
          style={{ visibility: page > 1 ? 'visible' : 'hidden' }}
        >
          <span className='regular'>{I18n.t('main.index.previous_page')}</span>
          <span className='mobile'>«</span>
        </a>
      </div>
      <span className='regular'>{I18n.t('react.search.pagination.results', { start, end, total })}</span>
      <span className='mobile'>{I18n.t('react.search.pagination.results_mobile', { start, end, total })}</span>
      <div className='right-button'>
        <a
          className='button'
          href={nextPage ? nextPage.href : '#'}
          onClick={handleNextPage}
          style={{ visibility: page < pages ? 'visible' : 'hidden' }}
        >
          <span className='regular'>{I18n.t('main.index.next_page')}</span>
          <span className='mobile'>»</span>
        </a>
      </div>
    </div>
  )
}

export default React.memo(Pagination)
